import { ActionPattern, all, call, fork, put, takeLatest } from 'redux-saga/effects';

import { BedayaAction } from '../../types/BedayaAction';
import { getSettingsRequest } from '../actions/common_actions';
import {
  NEXODUS_CONNECT,
  NEXODUS_IMPORT_INVOICE,
  NEXODUS_WEBHOOK,
  nexodusConnectFailure,
  nexodusConnectSuccess,
  nexodusImportInvoiceFailure,
  nexodusImportInvoiceSuccess,
  nexudusWebhookFailure,
  nexudusWebhookSuccess,
} from '../actions/nexodus_actions';
import { putSettings } from '../api/common';
import { deleteWebhook, getImportInvoice, postConnect } from '../api/nexodus';

function* nexodusConnectSaga(action: BedayaAction) {
  try {
    yield call(postConnect, action.data);
    yield put(nexodusConnectSuccess({}));
    yield put(getSettingsRequest({ system: 'nexudus' }));
  } catch (error) {
    let processedError;
    try {
      processedError = JSON.parse(error.message);
    } catch (e) {
      console.error(e);
    }
    yield put(nexodusConnectFailure(processedError || error));
  }
}

function* nexudusWebhookSaga(action: BedayaAction) {
  try {
    if (action.data.webhookUrl) {
      yield call(putSettings, { system: 'nexudus', data: { webhookUrl: action.data.webhookUrl } });
    } else {
      for (const id of action.data.ids) {
        yield call(deleteWebhook, id);
      }
    }
    yield put(nexudusWebhookSuccess());
    yield put(getSettingsRequest({ system: 'nexudus' }));
  } catch (error) {
    let processedError;
    try {
      processedError = JSON.parse(error.message);
    } catch (e) {
      console.error(e);
    }
    yield put(nexudusWebhookFailure(processedError || error));
  }
}

function* nexodusImportInvoiceSaga(action: BedayaAction) {
  try {
    yield call(getImportInvoice, action.data.invoiceNumber);
    yield put(nexodusImportInvoiceSuccess());
  } catch (error) {
    let processedError;
    try {
      processedError = JSON.parse(error.message);
    } catch (e) {
      console.error(e);
    }
    yield put(nexodusImportInvoiceFailure(processedError || error));
  }
}

function* nexodusConnectWatcher() {
  yield takeLatest(NEXODUS_CONNECT.REQUEST as ActionPattern, nexodusConnectSaga);
}

function* nexudusWebhookWatcher() {
  yield takeLatest(NEXODUS_WEBHOOK.REQUEST as ActionPattern, nexudusWebhookSaga);
}

function* nexodusImportInvoiceWatcher() {
  yield takeLatest(NEXODUS_IMPORT_INVOICE.REQUEST as ActionPattern, nexodusImportInvoiceSaga);
}

export default function* nexodosSagas() {
  yield all([fork(nexodusConnectWatcher), fork(nexudusWebhookWatcher), fork(nexodusImportInvoiceWatcher)]);
}
